import React from 'react';
export default /*#__PURE__*/React.createContext({
  getScrollContainer: function getScrollContainer() {
    return window;
  },
  registerDependencies: function registerDependencies() {},
  handleValuesChange: function handleValuesChange() {}
});